import { OrderItemSerializable } from './order-item-serializable';

export class SfdcBonusCreditTransferOrderItemSerializable extends OrderItemSerializable {
  sfdcBonusCreditTransfer: number = null;
}
